<template>
  <div>
    <v-flex v-if="simc && showSelect" xs12>
      <v-autocomplete
        id="street"
        v-model="selectedULIC"
        clearable
        outlined
        hide-no-data
        placeholder="Wpisz nazwę ulicy"
        item-text="nameFull"
        item-value="symbol"
        :disabled="disabled"
        :items="streets"
        :search-input.sync="search"
        :label="label"
        :error-messages="errorMessages"
        @focus="focus('street')"
        @blur="blur('street')"
        @change="changeStreet"
      />
    </v-flex>
  </div>
</template>

<script>
import axios from 'axios';

import { notificationsMixin } from '@/mixins/notifications';

// @vuese
// Input na ULIC-a
// @group Forms
export default {
  mixins: [notificationsMixin],
  props: {
    // Schema
    model: {
      type: Object,
      required: true
    },
    // Nazwa pola z ULIC-em
    field: {
      type: String,
      required: false,
      default: 'ulic'
    },
    // Wartość TERC-a
    terc: {
      type: String,
      required: true
    },
    // Wartość SIMC-a
    simc: {
      type: String,
      required: true
    },
    // Nazwa miasta
    city: {
      type: String,
      required: false
    },
    // Czy pola mają być disabled
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      streets: [],
      search: '',
      selectedULIC: undefined,
      showSelect: false,
      label: this.model.street.$schema.fieldRequired ? 'Ulica *' : 'Ulica'
    };
  },
  computed: {
    errorMessages() {
      return this.model.street.$error;
    }
  },
  watch: {
    simc() {
      this.streets = [];
      this.model.$setData({
        street: '',
        [this.field]: ''
      });
      this.checkULICList();
    },
    search(val) {
      if (val) {
        return this.searchULICList(val);
      }
      return this.getAllStreets();
    }
  },
  beforeMount() {
    this.checkULICList();
    this.setULICData();
  },
  methods: {
    // @vuese
    // Zwraca cała listę ulic
    getAllStreets() {
      axios.get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}`).then(res => {
        this.streets = res.data.list;
      });
    },
    // @vuese
    // Sprawdza czy lista ulic nie jest pusta
    checkULICList() {
      if (this.terc && this.simc) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&count=1`)
          .then(res => {
            if (res.data.list.length === 0) {
              this.showSelect = false;
              this.model.$setData({
                street: this.city
              });
            } else {
              this.showSelect = true;
              this.getAllStreets();
            }
          })
          .catch(() => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Przeszukje listę ulic
    searchULICList(val) {
      if (this.terc && this.simc) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/?terc=${this.terc}&placeSymbol=${this.simc}&search=${val}`)
          .then(res => {
            this.streets = res.data.list;
          })
          .catch(() => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Ustawianie pól formularza
    setULICData() {
      this.selectedULIC = this.model[this.field].$value;
      if (this.model.street) {
        this.search = this.model.street.$value;
      } else if (this.selectedULIC) {
        this.findStreetName();
      }
    },
    // @vuese
    // Pobiera nazwę ulicy na podstawie symbolu ulicy
    findStreetName() {
      if (this.simc) {
        axios
          .get(`${process.env.VUE_APP_TERYT_API_URL}/ulic/${this.simc}/${this.model[this.field].$value}`)
          .then(res => (this.search = res.data.list))
          .catch(() => this.notifyError('Nie udało się pobrać listy ulic'));
      }
    },
    // @vuese
    // Zapisanie w schema odpowiednich pól po wybraniu ulicy
    changeStreet(val) {
      this.model.$setData({
        street: val ? this.streets.find(item => item.symbol === val).nameFull : '',
        [this.field]: val ? val : ''
      });
    },
    // @vuese
    // Focus na polu
    focus(field) {
      this.model[field].$hasFocus = true;
    },
    // @vuese
    // Blur na polu
    blur(field) {
      this.model[field].$hasFocus = false;
    }
  }
};
</script>
